import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { AppState } from "../../app.state";
import { buscarEntrada } from "../../states/busqueda/actions";
import { SearchCustomParamsComponent } from "../search-custom-params/search-custom-params.component";
import { MatCardModule } from "@angular/material/card";

@Component({
  selector: "app-search-input",
  standalone: true,
  imports: [
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    CommonModule,
    MatIconModule,
    MatCardModule,
  ],
  templateUrl: "./search-input.component.html",
  styleUrl: "./search-input.component.css",
})
export class SearchInputComponent {
  public busquedaDescripcion: string = "";
  public dialogRef: any;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private store: Store<AppState>
  ) {}

  onEnter(event: any): void {
    event.preventDefault();
    if (this.busquedaDescripcion) {
      this.router.navigate(["/consulta"]);
      this.store.dispatch(
        buscarEntrada({
          busqueda: this.busquedaDescripcion.trim(),
          tipoBusqueda: "busquedaSencilla",
          request: [],
        })
      );
    
    }
  }

  openDialog(): void {
    const headerElement = document.getElementById("buscador");
    const drawerSidenav = document.getElementById("drawer-sidenav");
    const drawerSidenavWidth = drawerSidenav ? drawerSidenav.clientWidth : 500;
    console.log("drawerSidenavWidth", drawerSidenavWidth);

    const headerWidth = headerElement ? headerElement.clientWidth : 16;
    this.dialog.open(SearchCustomParamsComponent, {
      width: `${headerWidth}px`,
      maxWidth: "100vw",
      panelClass: "custom-modal-container",
      backdropClass: "transparent-backdrop",
      hasBackdrop: true,
      position: {
        top: "50px",
        left: `${drawerSidenavWidth}px`,
      },
      data: {
        busquedaDescripcion: this.busquedaDescripcion,
      },
    });
  }
}
